import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button} from "reactstrap"
import {getExportShippingOrdersCSVv41} from "../../../services/api/apiBarcode"

class ExportShipping extends Component {
    _exportShipping = () => {
        try {
            const {filter} = this.props
            let tagsExport = []
            if(filter.tags)  tagsExport.push(...filter.tags)
            if(filter.list_tags) tagsExport.push(...filter.list_tags)

            const {list_tags, tags, ...rest} = filter

            const cloneFilter = Object.assign({}, rest)

            delete cloneFilter['created']
            delete cloneFilter['generated']

            if(tagsExport.length > 0){
                cloneFilter['tags[]'] = tagsExport
            }

            if (filter.created.hasOwnProperty('from')) {
                cloneFilter['created[$gte]'] = filter.created.from
            }

            if (filter.created.hasOwnProperty('to')) {
                cloneFilter['created[$lte]'] = filter.created.to
            }

            if (filter.generated.hasOwnProperty('from')) {
                cloneFilter['generated[from]'] = filter.generated.from
            }

            if (filter.generated.hasOwnProperty('to')) {
                cloneFilter['generated[to]'] = filter.generated.to
            }

            delete cloneFilter['barcodeNumber']

            if (filter.barcodeNumber.hasOwnProperty('$gte')) {
                cloneFilter['barcodeNumber[$gte]'] = filter.barcodeNumber['$gte']
            }

            if (filter.barcodeNumber.hasOwnProperty('$lte')) {
                cloneFilter['barcodeNumber[$lte]'] = filter.barcodeNumber['$lte']
            }

            if (filter.hasOwnProperty('generate_label_config.delay_days')) {
                if (filter['generate_label_config.delay_days'].hasOwnProperty('from')) {
                    cloneFilter['generate_label_config.delay_days[from]'] = filter['generate_label_config.delay_days'].from
                    delete cloneFilter['generate_label_config.delay_days']
                }

                if (filter['generate_label_config.delay_days'].hasOwnProperty('to')) {
                    cloneFilter['generate_label_config.delay_days[to]'] = filter['generate_label_config.delay_days'].to
                    delete cloneFilter['generate_label_config.delay_days']
                }
            }

            if(filter.is_fba) {
                if(filter.is_fba === 'TikTok'){
                    cloneFilter.is_tiktok = 'y'
                    delete cloneFilter.is_fba
                }else if(filter.is_fba === 'n'){
                    cloneFilter.is_tiktok = 'n'
                }
            }
            
            window.location.href = getExportShippingOrdersCSVv41({...cloneFilter})
        } catch (err) {
            alert(err.message)
        }
    }

    render() {
        return (
            <Button className="btn btn-warning btn-labeled btn-labeled-left ml-1" onClick={this._exportShipping}>
                <b><i className="mi-local-shipping"/></b>
                Export Shipping
            </Button>
        )
    }
}

ExportShipping.propTypes = {
    filter: PropTypes.object.isRequired
}

export default ExportShipping
